module.exports = __webpack_public_path__ + "static/img/3.bee2e5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/cha/3.png
// module id = 93dC
// module chunks = 1